import { GetStaticProps, CasinoPage } from "../../bet-nextv1/CasinoPage";

export default CasinoPage;

export const getStaticProps = GetStaticProps;